module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"all":"Alle Nachrichten","title":"Neueste Nachrichten"},"en":{"all":"All news","title":"Latest news"},"it":{"all":"","title":""},"lt":{"all":"Visos naujienos","title":"Paskutinės naujienos"},"pl":{"all":"Wszystkie wiadomości","title":"Najnowsze wiadomości"}}')
  delete Component.options._Ctor
}
